import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className="button--duplicate" icon='duplicate'>{ children ? children : 'Duplicate' }</Button>
}